export * from './baCheckbox.component';



// WEBPACK FOOTER //
// /Desenvolvimento/PMP/painel/src/app/theme/components/baCheckbox/index.ts